<template src="./ArchiveList.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import BrandSelect from "@/components/components/BrandSelect"
import SearchQuery from "@/components/suppliers/components/SearchQuery"
import TopMenu from "@/components/suppliers/components/topMenu"
import {config} from "@/config";

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/archiveList');

export default {
  name: "SuppliersTaskList",
  components: {
    BrandSelect,
    SearchQuery,
    TopMenu,
  },
  data() {
    return {
      showOverlay: 0,
      offset: 0,
      updateFrequency: config.updateFrequency
    }
  },
  methods: {
    ...mapActions(['SAVE', 'GET_DATA', 'DELETE', 'ARCHIVING']),

    getVariant: function(isReady) {
      if (isReady) {
        return 'success';
      }

      return 'secondary';
    },

    perPage : function (perPage) {
      this.$store.commit('suppliers/archiveList/PER_PAGE', perPage)
      this.limit = perPage
      this.updateTaskList(this.offset)
    },

    updateTaskList: function (offset) {
      if (offset === undefined) {
        offset = this.offset;
      } else {
        this.offset = offset;
      }
      this.GET_DATA({th: this, offset: offset})
    },

    taskDelete: function (id, ref) {
      this.$refs[ref][0].$el.classList.add('toggle');
      this.DELETE({th: this, taskId: id});
    },
    taskArchiving: function (id, ref) {
      this.$refs[ref][0].$el.classList.add('toggle');
      this.ARCHIVING({th: this, taskId: id});
    },
  },
  computed: {
    ...mapGetters([
      'TASKS',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
    ]),
    currentPage: function () {
      return this.offset;
    },
  },
  mounted() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
  created() {
    this.updateTaskList();
    var th = this;
    setInterval(() => {
      if (th.$router.currentRoute.name == 'suppliersTaskList') {
        th.updateTaskList();
      }
    }, th.updateFrequency);
  },
}
</script>

<style scoped>

.task-list .card-header .btn-warning.btn-block,
.task-list .card-header .btn-secondary.btn-block,
.task-list .card-header .btn-dark.btn-block,
.task-list .card-header .btn-info.btn-block,
.task-list .card-header .btn-success.btn-block {
  width: 84%;
}
.task-list .card-header .btn-danger.btn-block {
  width: 15%;
  float: right;
}
.toggle .waiting-state {
  display: none;
}
.toggle .process-state {
  display: inline;
}
.process-state {
  display: none;
}
.task-list .btn-block + .btn-block {
  margin-top: 0;
}
.text-align-left {
  text-align: left;
}
.task-list .width-100 {
  width: 100%;
  padding-bottom: 10px;
}
.task-list .btn-load {
  float: left;
  margin-top: 0.5rem;
}
.count-error-box {
  float: left;
  width: 50px;
}

</style>